//External
import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import { formatMoney, formatMoneyLocalString } from "utils";

/*******************
@Purpose : Used for price details
@Parameter : {breakDownObj}
@Author : INIC
******************/
const PriceDetail = ({
  breakDownObj,
  emailMeQuota,
  isShowEmailMeQuotaInPriceDetail,
  deliveryType,
  start_address,
  return_address,
  is_pickup_selected,
  one_way_option,
  is_delivery_tbd,
  is_return_tbd,
}) => {

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {breakDownObj?.perDayCharge && (
        <Fragment>
          {" "}
          <hr />
          <div className="user-booking-details d-none d-lg-block">
            <div className="d-flex justify-content-end align-items-center">
              {isShowEmailMeQuotaInPriceDetail && (
                <div className="email-quote">
                  <Button
                    variant="link"
                    className="p-0 link-btn ff-hel-reg font-14 text-primary-light gtEmailMeQuote text-decoration-none"
                    onClick={emailMeQuota}
                  >
                    Email me quote
                  </Button>
                </div>
              )}
            </div>
            <ul className="list-unstyled mb-0 rental-list mt-space-0">
              <li>
                <div className="rental-charges">
                  <span>
                    ${formatMoneyLocalString(breakDownObj.perDayCharge)} x{" "}
                    {breakDownObj.days}d
                  </span>
                  <span className="fw-500">
                    ${formatMoney(breakDownObj?.rentalCharge)}
                  </span>
                </div>

                {breakDownObj.hours > 0 && (
                  <div className="rental-charges">
                    <span>
                      ${breakDownObj.perHourCharge} x {breakDownObj.hours}h
                    </span>
                    <span className="fw-500">
                      ${formatMoney(breakDownObj?.totalHourCharge)}
                    </span>
                  </div>
                )}

                {breakDownObj.weeklyDiscount > 0 && (
                  <div className="rental-charges">
                    <span>Weekly Discount</span>
                    <span className="text-success fw-500">
                      -${formatMoney(breakDownObj?.weeklyDiscount)}
                    </span>
                  </div>
                )}

                {breakDownObj.monthlyDiscount > 0 && (
                  <div className="rental-charges">
                    <span>Monthly Discount</span>
                    <span className="text-success fw-500">
                      -${formatMoney(breakDownObj?.monthlyDiscount)}
                    </span>
                  </div>
                )}

                {breakDownObj.underageFee > 0 && (
                  <div className="rental-charges">
                    <span>
                      Underage Fee ({breakDownObj.underageFeePercent}%)
                    </span>
                    <span className="fw-500">
                      ${formatMoney(breakDownObj?.underageFee)}
                    </span>
                  </div>
                )}

                {!is_pickup_selected && start_address && (
                  <div className="rental-charges">
                    <span>
                      {one_way_option
                        ? "Delivery Fee"
                        : "Delivery & Return Fee"}{" "}
                    </span>
                    {breakDownObj.deliveryFee !== null ? (
                      <span className="fw-500">
                        {breakDownObj.deliveryFee === 0 ? (
                          <span className="text-success">comp</span>
                        ) : breakDownObj.deliveryFee > 0 ? (
                          "$" +
                          formatMoney(Math.round(breakDownObj?.deliveryFee))
                        ) : (
                          "TBD"
                        )}
                      </span>
                    ) : (
                      <span>Calculating...</span>
                    )}

                    {/* <span>{breakDownObj.deliveryFee}</span> */}
                  </div>
                )}
                {one_way_option && return_address && (
                  <div className="rental-charges">
                    <span>Return Fee</span>
                    {breakDownObj?.returnFee !== null ? (
                      <span className="fw-500">
                        {breakDownObj.returnFee === 0 ? (
                          <span className="text-success">comp</span>
                        ) : breakDownObj.returnFee > 0 ? (
                          "$" + formatMoney(Math.round(breakDownObj?.returnFee))
                        ) : (
                          "TBD"
                        )}
                      </span>
                    ) : (
                      <span className="fw-500">Calculating...</span>
                    )}
                  </div>
                )}

                {breakDownObj?.securityDepositAdmin > 0 && (
                  <div className="rental-charges">
                    <span>Security Deposit</span>
                    <span className="fw-500">
                      ${formatMoney(breakDownObj?.securityDepositAdmin)}
                    </span>
                  </div>
                )}

                {breakDownObj?.vehicleProtectionValue > 0 && (
                  <div className="rental-charges">
                    <span>Collision Damage Waiver</span>
                    <span className="fw-500">
                      ${formatMoney(breakDownObj?.vehicleProtectionValue)}
                    </span>
                  </div>
                )}

                {breakDownObj?.deductible > 0 && (
                  <div className="rental-charges">
                    <span>Deductible</span>
                    <span className="text-success fw-500">
                      -${formatMoney(breakDownObj?.deductible)}
                    </span>
                  </div>
                )}
                <div className="rental-charges">
                  <span>Taxes & Fees</span>
                  <span className="fw-500">
                    ${formatMoney(breakDownObj?.taxesFees)}
                  </span>
                </div>
              </li>

              <li className="rental-charges mb-spaces">
                <h3 className="mb-0 ff-hel-bold text-dark font-24">
                  Total Charges
                </h3>
                <h3 className="mb-0 ff-hel-bold total-price font-24 text-dark">
                  ${formatMoney(breakDownObj?.totalCharge)}
                </h3>
              </li>
            </ul>
          </div>
        </Fragment>
      )}
    </>
  );
};

export default PriceDetail;
